import { render, staticRenderFns } from "./time.vue?vue&type=template&id=3bccca2c&scoped=true&"
import script from "./time.vue?vue&type=script&lang=ts&"
export * from "./time.vue?vue&type=script&lang=ts&"
import style0 from "./time.vue?vue&type=style&index=0&id=3bccca2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bccca2c",
  null
  
)

export default component.exports